import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FieldValues, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { VAMethodologyService } from "../../../../Component/Api/VerificationAgency/VaMethodology/VAMethodologyService";
import { AppQuill } from "../../../../Component/Common/Components/FormValidationInputs/AppQuill";
import { MDBox } from "../../../../Component/Common/Components/MDBox";
import { MDTypography } from "../../../../Component/Common/Components/MDTypography";
import { IDropDownTabOptions } from "../../../../Component/Common/Components/OptionsSelectDropdown/OptionsSelectDropdown";
import { VaMethodology } from "../../../../Component/Model/Dto/VerificationAgency/VaMethodology";
import { CustomDialogTitle } from "../../../Common/Custom/CustomDialogTitle";
import { VaMethodologySchema } from "./VaMethodologyFormValidation";

interface IProps {
  scorecardElement: IDropDownTabOptions;
  handleCloseModal: () => void;
  showModal: boolean;
  selectedPage: string;
}

export const VaMethodologyCreateModal = (props: IProps) => {

  const { control, handleSubmit, formState: { isSubmitting }, } = useForm({
    mode: "all",
    resolver: yupResolver(VaMethodologySchema),
  });

  const handleDataSubmit = async (data: FieldValues) => {
    try {
      const requestData = {
        id: 0,
        requirementDescription: data.requirementsDescription,
        scorecardElementTypesEnum: props.scorecardElement.id,
        sortOrder: 0
      } as VaMethodology.VaMethodologyDataSubmit;

      await VAMethodologyService.Upsert(
        requestData
      );

      toast.success("Created successfully");
      props.handleCloseModal();
    } catch (error: any) {
      console.log(error);
    }
  };

  return (
    <>
      <Dialog open={props.showModal} onClose={() => props.handleCloseModal()}>
        <CustomDialogTitle id="assign-dialog-title" onClose={() => props.handleCloseModal()}>
          {`Create New ${props.selectedPage} Methodology`}
        </CustomDialogTitle>
        <DialogContent>
          <Grid container spacing={1} component="form" id='SaveNewMethodologyForm' onSubmit={handleSubmit(handleDataSubmit)}>
            <Grid item xs={12}>
              <MDTypography variant="h6">Scorecard Element - {props.scorecardElement.value}</MDTypography>
            </Grid>
            <Grid item xs={12}>
              <MDBox className="leftAlign">
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  sx={{ color: grey, fontSize: "0.85em" }}
                >
                  Requirement Description
                </MDTypography>
                <AppQuill
                  control={control}
                  name="requirementsDescription"
                  placeholder="Details..."
                  maxLength={1000}
                />
              </MDBox>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isSubmitting}
            variant="contained"
            color="primary"
            form="SaveNewMethodologyForm"
            type="submit"
          >
            Save
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
